exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".camera[data-v-2151036e]{align-items:center;text-align:center;border:1px solid #d1d1d1;display:flex;height:auto;min-height:170px}.camera button[data-v-2151036e]{margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2151036e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/qr.vue
// module id = 283
// module chunks = 0